const page_plan_your_stay = document.getElementById("page-plan_your_stay");

if (page_plan_your_stay) {
  //% Get url parameters and store the tour label
  const urlParams = new URLSearchParams(window.location.search);
  const tour_slug = urlParams.get("tour");

  //% Form Select Buttons
  const buttons_form_select = page_plan_your_stay.querySelectorAll(".btn-form-select");
  //% Both enquiry form containers
  const enquiry_forms_wrappers = page_plan_your_stay.querySelectorAll(".form-wrapper");

  //% Logic for buttons to select the correct enquiry form
  buttons_form_select.forEach((button) => {
    button.onclick = () => {
      const form_type = button.dataset.select;
      const selected_form = page_plan_your_stay.querySelector(`.form-wrapper[data-type="${form_type}"]`);

      buttons_form_select.forEach((btn) => {
        btn.classList.remove("active");
      });
      enquiry_forms_wrappers.forEach((wrapper) => {
        wrapper.classList.remove("active");
      });

      button.classList.add("active");
      // enquiry_forms_wrappers
      selected_form.classList.add("active");
    };
  });

  //% Enquiry Form Sent to Viatu
  const form_for_traveller = document.getElementById("for-traveller");

  //% Enquiry Form Sent to Lalibela
  const form_for_agent = document.getElementById("for-agent");

  //! Scope the traveller enquiry form
  if (form_for_traveller) {
    const form = document.getElementById("form-enquiry-traveller");
    const response_message = form.querySelector(".response-message");

    //% Form inputs
    const input_travel_dates = form.querySelector("#travel_dates");
    const input_select_tours = form.querySelector("#tour_selection");
    const input_adults = form.querySelector("#adults");
    const input_children = form.querySelector("#children");
    const input_first_name = form.querySelector("#first_name");
    const input_last_name = form.querySelector("#last_name");
    const input_email = form.querySelector("#email");
    const input_phone = form.querySelector("#phone");
    const input_comments = form.querySelector("#comments");
    const input_check_consent = form.querySelector("#consent");

    const btn_submit = form.querySelector("#form-enquiry-traveller-btn-submit");
    let isBusy = false;

    //% Set up flatpickr date input
    flatpickr(input_travel_dates, {
      minDate: "today",
      mode: "range",
      onChange: function (selectedDates, dateStr, flatpickr) {
        const [start_range, end_range] = selectedDates;
        // console.log(flatpickr);

        if (start_range && end_range) {
          //% Extract date values needed for API request
          // viatu_form_data.startDate = flatpickr.formatDate(start_range, "Y-m-d");
          // viatu_form_data.endDate = flatpickr.formatDate(end_range, "Y-m-d");
          // viatu_form_data.selectedYear = flatpickr.currentYear;
          // viatu_form_data.selectedMonth = flatpickr.currentMonth;
          // console.log(viatu_form_data);
        }
      },
    });

    //# Pre-select the corrected tour option based on url param
    //% Loop over each option to see if any of them needs to be pre-selected
    Array.from(input_select_tours.children).forEach((tour, index) => {
      //$ If the option's data-tour attr matches the tour url param then select it by index
      if (tour.dataset.slug === tour_slug) {
        input_select_tours.selectedIndex = index;
      }
    });

    // checkFormInputErrors(form);

    btn_submit.onclick = (event) => {
      event.preventDefault();
      // console.log("submit traveller form");

      //% Exit if form is busy posting
      if (isBusy) return;

      //% Set busy status
      isBusy = true;
      //$ Clear Previous Form Errors
      clearFormInputErrors(form);
      form.classList.add("busy");

      //% Get Current Tour Selection item
      const selected_tour = input_select_tours.options[input_select_tours.selectedIndex];

      //% Locale data from localStorage
      const country_code = JSON.parse(localStorage.getItem("locale_data"))?.country_code;

      //% Append comments with tour title
      const comments = `Comments for the '${selected_tour.dataset.title}' (ID:${input_select_tours.value}) itinerary: 
      ${input_comments.value}`;

      //% Extract and Save the enquiry form values to send to Viatu API
      const viatu_form_data = {
        budget: {
          // budgetTo: null, // no option for budget, might have to use tour rate * days and convert to euro
          budgetTo: parseInt(selected_tour.dataset.rate),
        },
        dates: {
          startDate: null,
          endDate: null,
          selectedYear: null,
          selectedMonth: null, // 0 based months, 3 = April
        },
        enquiryData: {
          name: input_first_name.value,
          lastname: input_last_name.value,
          email: input_email.value,
          //todo [E.164 int format] need to make this E.164 international format later
          phone: input_phone.value.startsWith("+") ? input_phone.value : `+${input_phone.value}`,
          comments: comments,
          country: country_code ?? "ZA", //"ZA is default if no country code found in localStorage"
        },
        travellers: {
          adults: parseInt(input_adults.value, 10) || 1,
          //todo add birth date from 10 years ago for each child ["2015-01-01"]
          // children: [input_children.value === "" ? "0" : input_children.value],
          //$ Adds generic birthdate in array for each child based on children count input value
          children: (() => {
            const children = [];
            const count = parseInt(input_children.value === "" ? null : input_children.value);
            for (let i = 0; i < count; i++) {
              children.push("2015-01-01");
            }
            return children;
          })(),
          // ugly way of getting rough room number, total people / 2
          // rooms: Math.ceiling( ( (parseInt(input_adults.value) || 1) + (parseInt(input_children.value) || 0) ) / 2),
          rooms: 1,
        },
      };

      //% Date Handling only if start and end dates have been selected
      const flatpick_dates = input_travel_dates._flatpickr;
      const [start_range, end_range] = flatpick_dates?.selectedDates;
      if (start_range && end_range) {
        //$ Extract date values needed for API request
        viatu_form_data.dates.startDate = flatpick_dates.formatDate(start_range, "Y-m-d");
        viatu_form_data.dates.endDate = flatpick_dates.formatDate(end_range, "Y-m-d");
        viatu_form_data.dates.selectedYear = flatpick_dates.currentYear;
        // viatu_form_data.dates.selectedMonth = flatpick_dates.currentMonth;
        viatu_form_data.dates.selectedMonth = start_range.getMonth();
      }

      submitViatu(viatu_form_data);
    };

    //# Fn Submit to Viatu api
    async function submitViatu(input_data) {
      /* GraphQL */
      //! GraphQL Mutation
      const query = `
    mutation mutateMakeWizardEnquiry(
      $enquiry: TripWizardEnquiryInput
      $id: ID = null
      $referralCode: String = null
      $userPreferences: UserPreferencesInput
    ) {
      makeWizardEnquiry(
        enquiry: $enquiry
        id: $id
        referralCode: $referralCode
        userPreferences: $userPreferences
      ) {
        quote(userPreferences: $userPreferences) {
          reference
          chfValue      
        }
        ok    
      }
    }`;

      const variables = {
        enquiry: {
          budget: {
            ...input_data.budget,
            selectedBudget: "", // no idea what this is
          },
          dates: {
            ...input_data.dates,
            hasSpecificDates: true,
          },
          destinations: {
            selectedDestinations: [
              "151", //  South Africa
            ],
          },
          enquiryData: {
            ...input_data.enquiryData,
            bookedFlights: false,
            communicationPreferredMethod: "email", //todo [or phone] add option to form at later stage
            // country: "ZA",
            includeCar: false,
            onlyFlexibleCancellation: false, // not used anymore
            promoCode: "LALIBELA",
          },
          experiences: {
            selectedExperiences: [],
          },
          travellers: {
            ...input_data.travellers,
          },
          source: "Leadgen",
          medium: "Lalibela",
          //$ Get trip id from the selected tour value which is set to Viatu's tour ID's
          tripId: input_select_tours.value,
        },
        // id: null, // add tour ID in here
        id: null, // add tour ID in here
        // id: parseInt(input_select_tours.value), // add tour ID in here
        referralCode: null,
        userPreferences: {
          //$ Use the full url of the current enquiry page
          referrer: window.location.href,
          langCode: "en", //required but using defaults
          //todo select currency based on country
          // currency: "ZAR", //optional - using defaults
        },
      };

      const api_endpoint = (() => {
        //$ check server host name
        const host = window.location.hostname;
        //$ IF server is Production set endpoint to production
        if (host === "lalibela.travel") {
          // return true;
          return "https://api.viatu.com/graphql";
        }
        //$ Else default to staging endpoint
        // return false;
        return "https://api.staging.viatu.com/graphql";
      })();

      // console.log(window.location.hostname);
      // console.log(api_endpoint);

      // const endpoint = "https://api.staging.viatu.com/graphql";
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${AUTH_TOKEN}`, // remove this line if not needed
        },
        body: JSON.stringify({
          query,
          variables,
        }),
      };
      try {
        //% Check form for any input errors before trying to post to api
        checkFormInputErrors(form);
        // console.log(variables);

        //^ Do POST request
        const request = await fetch(api_endpoint, options);
        // console.log(request);
        //^ Handle Response
        const response = await request.json();
        // console.log(response);

        //% On success
        if (response?.data?.makeWizardEnquiry?.ok) {
          const quote_reference = response?.data.makeWizardEnquiry?.quote?.reference;
          //$ Reset and clear all form field values
          // resetForm(form);
          form.reset();
          //$ Set success response message
          response_message.innerText = "Thank you for your enquiry, we will get back to you soon.";
          //$ Log out the quote reference
          console.log(quote_reference);
          //$ Trigger Event for GA4 Tracking
          triggerEvent(document, "form_submission", form.id);
        }

        //^ Handle Errors
      } catch (err) {
        // console.error(err);
        // console.error("Sumbition failed");
      }

      //% Reset busy status
      isBusy = false;
      form.classList.remove("busy");
    }
  }

  //! Scope the agent enquiry form
  if (form_for_agent) {
    const form = document.getElementById("form-enquiry-agent");
    const response_message = form.querySelector(".response-message");

    //% Form inputs
    const input_travel_dates = form.querySelector("#travel_dates");
    const input_select_tours = form.querySelector("#tour_selection");

    // const input_select_tours = form.querySelector("#tour_selection");
    // const input_adults = form.querySelector("#adults");
    // const input_children = form.querySelector("#children");
    // const input_first_name = form.querySelector("#first_name");
    // const input_last_name = form.querySelector("#last_name");
    // const input_email = form.querySelector("#email");
    // const input_phone = form.querySelector("#phone");
    // const input_comments = form.querySelector("#comments");
    // const input_check_consent = form.querySelector("#consent");

    //$ Honeypot
    const honey_pot_field = form.querySelector("#hp");

    const btn_submit = form.querySelector("#form-enquiry-agent-btn-submit");

    let isBusy = false;

    //# Pre-select the corrected tour option based on url param
    //% Loop over each option to see if any of them needs to be pre-selected
    Array.from(input_select_tours.children).forEach((tour, index) => {
      //$ If the option's data-tour attr matches the tour url param then select it by index
      if (tour.dataset.slug === tour_slug) {
        input_select_tours.selectedIndex = index;
      }
    });

    //% Set up flatpickr date input
    flatpickr(input_travel_dates, {
      minDate: "today",
      mode: "range",
    });

    btn_submit.onclick = (event) => {
      event.preventDefault();
      // console.log("submit agent form");

      //$ Exit if form is busy posting
      if (isBusy) return;

      //% Logic when form is busy posting
      isBusy = true;
      // response_message.innerText = null;
      clearFormInputErrors(form);
      form.classList.add("busy");

      submitLalibela();
    };

    //# Fn Submit Enquiry to Lalibela via WP
    async function submitLalibela() {
      const endpoint = window.origin + "/wp-json/contact-form-7/v1/contact-forms/43/feedback";
      const options = {
        method: "POST",
        body: new FormData(form),
      };
      // console.log(options.body);
      try {
        //% Check for form errors before attempting to submit
        checkFormInputErrors(form);

        //% AJAX Post Request to Contact form 7 form
        const response = await submitForm(endpoint, options, honey_pot_field);
        // console.log(response);

        //% Set response message
        // response_message.innerText = response?.message || null;
        //% On submit success
        if (response?.status === "mail_sent") {
          //$ Reset form inputs
          form.reset();
          //$ Set form response message to success
          response_message.innerText = "Thank you for your enquiry, we will get back to you soon.";
          //$ Trigger Event for GA4 Tracking
          triggerEvent(document, "form_submission", form.id);
        }
      } catch (error) {
        // console.log(error);
        //% If spam is detected
        if (error.message === "spam") {
          // console.error("spam");

          //% Lock the form out until page refresh by not reseting isBusy status
          //todo - set response message to false success
          response_message.innerText = "Try again later";
          return;
        }
      }

      //% Logic when form is busy posting
      isBusy = false;
      form.classList.remove("busy");
    }
  }

  //!---------- Form Functions ----------
  //# Fn to clear all form errors
  function clearFormInputErrors(form) {
    const inputs = form.querySelectorAll("input, select, textarea");
    const response_message = form.querySelector(".response-message");

    //% Clear Response
    response_message.innerText = null;

    //% Clear Input Error Classes
    inputs.forEach((input) => {
      input.classList.remove("input-error");
    });
  }

  function resetForm(form) {
    const inputs = form.querySelectorAll("input, select, textarea");
    const response_message = form.querySelector(".response-message");

    //% Clear response
    response_message.innerText = null;

    //% Reset all input values
    inputs.forEach((input) => {
      input.value = "";
      input.checked = false;
    });
  }

  //# Fn to check for input errors
  function checkFormInputErrors(form) {
    const inputs = form.querySelectorAll("input, select, textarea");
    const response_message = form.querySelector(".response-message");
    let error_message = "";

    inputs.forEach((input) => {
      const id = input.id;

      //% Travel Dates validation
      if (id === "travel_dates") {
        const isValid = input.value !== "";
        if (!isValid) {
          input.classList.add("input-error");
          error_message = "One or more fields are invalid. Please correct and try again.";
        }
      }

      //% Tour Selection validation
      if (id === "tour_selection") {
        const isValid = input.value !== "";
        if (!isValid) {
          input.classList.add("input-error");
          error_message = "One or more fields are invalid. Please correct and try again.";
        }
      }

      //% Adults validation
      if (id === "adults") {
        const isNumeric = /^\d+$/.test(input.value);
        if (!isNumeric) {
          input.classList.add("input-error");
          error_message = "One or more fields are invalid. Please correct and try again.";
        }
      }

      //% Children validation
      if (id === "children") {
        const isNumeric = /^\d+$/.test(input.value);
        //$ If input value is defined and numeric
        if (input.value && !isNumeric) {
          input.classList.add("input-error");
          error_message = "One or more fields are invalid. Please correct and try again.";
        }
      }

      //% Names validation
      if (id === "first_name" || id === "last_name") {
        const isValidName = input.value !== "" && /^[a-zA-ZÀ-ÿ' -]+$/.test(input.value.trim());
        if (!isValidName) {
          input.classList.add("input-error");
          error_message = "One or more fields are invalid. Please correct and try again.";
        }
      }

      //% Email validation
      if (id === "email") {
        const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value);
        if (!isValid) {
          input.classList.add("input-error");
          error_message = "One or more fields are invalid. Please correct and try again.";
        }
      }

      //% Phone validation
      if (id === "phone") {
        const isValid = /^\+?[1-9]\d{7,15}$/.test(input.value);
        if (!isValid) {
          input.classList.add("input-error");
          error_message = "One or more fields are invalid. Please correct and try again.";
        }
      }

      //% Comments Validation
      if (id === "comments") {
        const isSafeMessage = !/[<>]|script|on\w+=/i.test(input.value);
        if (!isSafeMessage) {
          input.classList.add("input-error");
          error_message = "The message contains invalid characters. Please correct and try again.";
        }
      }

      //% Consent validation
      if (input.name === "consent" && error_message === "") {
        // if (id === "consent-agent" || id === "consent-traveller") {
        const isChecked = input.checked;
        if (!isChecked) {
          error_message = "Please confirm that you have read and accept our privacy policy. ";
        }
      }
    });

    response_message.innerText = error_message;
    //% Throw error to catch if there are any errors in the fields
    if (error_message !== "") {
      // return false;
      throw new Error();
    }
  }
}
